import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  initTaskTypeList,
  setCurrentNavPage,
  setStatisticsYears,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setTaskTypeListFilterTitle,
  setStatisticsTaskCategorySelected
} from "Actions";
import { onError, renderYearsArrayBetweenStartDateAndNow } from "Utils";
import { fetchTaskTypeItems, fetchTaskCategoryList } from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";
import CategoryStatistics from "./CategoryStatistics";

class CategoryStatisticsPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, currentOrganization } = this.props;

    dispatch(setCurrentNavPage("SETTING_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    let startDate =
      currentOrganization.startDate && currentOrganization.startDate.date
        ? currentOrganization.startDate.date
        : "2020-01-01 00:00:00.000000";
    this.setState({ organizationUen: uen });

    dispatch(initTaskTypeList());
    dispatch(fetchTaskCategoryList()).then(
      res => {
        dispatch(
          setStatisticsTaskCategorySelected(res.action.payload.data.data[0])
        );
        dispatch(
          setStatisticsYears(renderYearsArrayBetweenStartDateAndNow(startDate))
        );
        dispatch(fetchTaskTypeItems());
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage, pageSize } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      this.props.dispatch(fetchTaskTypeItems());
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    this.props.dispatch(setTaskTypeListFilterTitle(""));
  }

  render() {
    return (
      <div className={`page-content`}>
        <CategoryStatistics uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  subMenuDirection: state.params.subMenuDirection,
  filter: state.taskTypes.list.filter,
  currentOrganization: state.auth.currentOrganization
});

// export default TaskTypeSettingsPage;
export default connect(mapStateToProps)(CategoryStatisticsPage);



// WEBPACK FOOTER //
// ./src/components/CategoryStatistics/CategoryStatisticsPage.js